import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { PeriodApiResponse } from '@features/insured/models/period/period.model'

@Injectable({
  providedIn: 'root'
})
export class PeriodService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.periodApiUrl

  public getById(uuid: string): Observable<PeriodApiResponse> {
    return this.http.get<PeriodApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public listAll(): Observable<PeriodApiResponse[]> {
    return this.http.get<PeriodApiResponse[]>(`${this.apiUrl}`)
  }
}
